import Editor from '@monaco-editor/react';
import { EditorContainer } from '../../../style';
import { useTemplateEditorDispatch, useTemplateEditorState } from '../../../../context/UseTemplateEditorContext';

type Theme = 'light' | 'vs-dark';

export const SnapshotEditorView = () => {
  const { compilationContext, editorSettings } = useTemplateEditorState();
  const dispatch = useTemplateEditorDispatch();

  const isValidJson = (inputString: string) => {
    try {
      JSON.parse(inputString);
      return true;
    } catch (e) {
      return false;
    }
  };

  const handleChange = (value: string) => {
    if (isValidJson(value)) {
      dispatch({
        type: 'UPDATE_SNAPSHOT_VALIDITY',
        payload: {
          snapshotValid: true,
        },
      });
      dispatch({
        type: 'SET_COMPILATION_CONTEXT',
        payload: {
          compilationContext: JSON.parse(value),
        },
      });
    } else {
      dispatch({
        type: 'UPDATE_SNAPSHOT_VALIDITY',
        payload: {
          snapshotValid: false,
        },
      });
    }
  };

  return (
    <EditorContainer data-testid="SnapshotView">
      <Editor
        options={{
          minimap: { enabled: false },
          automaticLayout: true,
          wordWrap: editorSettings.wordWrap,
        }}
        theme={editorSettings.theme as Theme}
        value={JSON.stringify(compilationContext, null, 2)}
        onChange={(value, event) => {
          handleChange(value);
        }}
        language="json"
      />
    </EditorContainer>
  );
};
